<template>
	<tbody>
		<tr class="link" @click="showDetails = !showDetails" :class="showDetails ? 'expanded' : ''">
			<td>{{ rowIndex }}</td>
			<td>{{ product.productId }}</td>
			<td>{{ product.artnr }}</td>
			<td>
				<Button v-if="isLoggedIn" label="KÖP" @click.stop="buy()" />
				{{ product.name }}
			</td>



		</tr>
		<tr v-if="showDetails">
			<td style="background:var(--bg-debug);"></td>
			<td colspan="10" style="background:var(--bg-debug);"> {{ product }}</td>
		</tr>
	</tbody>
</template>

<script>
import { userMixin } from '../../mixins/userMixin';
import { USER_STORE_ACTION } from '../../store/user-store';



export default {
	name: "TestProductRow",
	components: {},
	mixins: [userMixin],
	data() {
		return {
			showDetails: false
		};
	},
	props: {
		productId: Number,
		rowIndex: Number
	},
	computed: {

		product() {

			return this.$store.state.productStore.data.productList[this.productId]

		},

	},
	methods: {
		test() {
			this.showDetails = true
		},
		buy() {

			var data = { currentOrderId: this.currentOrderId, post: { productId: this.productId, quantity: 1 } }
			this.$store.dispatch({ type: USER_STORE_ACTION.ADD_PRODUCT_TO_ORDER, data: data });
		}

	}
};
</script>

<style scoped></style>